module.exports = __webpack_public_path__ + "static/media/sv-bt-package.48b5b87d.png";